import { render, staticRenderFns } from "./mycenter.vue?vue&type=template&id=785b65da&scoped=true"
import script from "./mycenter.vue?vue&type=script&lang=ts"
export * from "./mycenter.vue?vue&type=script&lang=ts"
import style0 from "./mycenter.vue?vue&type=style&index=0&id=785b65da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785b65da",
  null
  
)

export default component.exports